import styled from "styled-components";

export const ConversionContainer = styled.div`
    padding: 40px;
    display: flex;
    flex-direction: column;
    max-width: 100%;
    align-items: center;
`;
ConversionContainer.displayName = "ConversionContainer";
